import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class WarehousesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (warehouseId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(
                    <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                );

                try {
                    await apiCall('business/stock/warehouse/delete/'+warehouseId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire('Silindi!', 'Depo başarıyla silindi.', 'success');
            } else {
                Swal.fire('Hata!', 'Silme işlemi başarısız oldu.', 'error');
            }
        }
    }

    handleWarehouseDetail = (warehouseId) => {
        this.props.history.push(`/stock/warehouse-detail/${warehouseId}`);
    }

    render() {
        const {userPermissions} = this.props;
        const userHasViewPermission = userPermissions.includes('warehouse.view');
        const userHasDeletePermission = userPermissions.includes('warehouse.delete');

        const columns = [
            {
                name:'Depo Kodu',
                selector:row => row.code,
                sortable:true,
                minWidth: '130px',
                maxWidth: '150px',
                cell: row => (
                    <div style={{fontWeight: '600', color: '#495057', fontFamily: 'monospace', padding: '12px 8px'}}>
                        {row.code || '-'}
                    </div>
                )
            },
            {
                name:'Depo Adı',
                selector:row => row.name,
                sortable:true,
                grow: 2,
                wrap: true,
                cell: row => (
                    <div style={{fontWeight: '500', color: '#212529', padding: '12px 8px'}}>
                        {row.name}
                    </div>
                )
            },
            {
                name:'Şube',
                selector:row => row.branch ? row.branch.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Sorumlu',
                selector:row => row.manager_name || '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Telefon',
                selector:row => row.phone || '-',
                sortable:true,
                minWidth: '140px',
                maxWidth: '160px',
                cell: row => (
                    <div style={{fontFamily: 'monospace', fontSize: '13px', padding: '12px 8px'}}>
                        {row.phone || '-'}
                    </div>
                )
            },
            {
                name:'Durum',
                selector:row => row.is_active ? 'Aktif' : 'Pasif',
                sortable:true,
                minWidth: '100px',
                maxWidth: '120px',
                center: true,
                cell: row => (
                    <span className={`badge badge-${row.is_active ? 'success' : 'secondary'}`} style={{
                        fontSize: '11px',
                        padding: '8px 12px',
                        fontWeight: '600',
                        minWidth: '65px',
                        display: 'inline-block'
                    }}>
                        {row.is_active ? 'Aktif' : 'Pasif'}
                    </span>
                )
            },
            {
                name: 'İşlem',
                button: true,
                minWidth: '140px',
                maxWidth: '160px',
                center: true,
                cell: row => (
                    <div style={{display: 'flex', gap: '6px', justifyContent: 'center', padding: '8px'}}>

                        {userHasDeletePermission && (
                            <IconButton 
                                className="btn btn-outline-danger"
                                onClick={() => this.handleDelete(row.id)}
                                style={{padding: '8px 14px'}}>
                                <i className="icon-trash" style={{fontSize: '16px'}}></i>
                            </IconButton>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                onRowClicked={userHasViewPermission ? row => this.handleWarehouseDetail(row.id) : undefined}
                dataEndpoint="business/stock/warehouse/all"
            />
        );
    }
}

export default withPermissions(withRouter(WarehousesTable));
